import { render } from "./LimitActivePassForm.vue?vue&type=template&id=4fdf335d"
import script from "./LimitActivePassForm.vue?vue&type=script&lang=js"
export * from "./LimitActivePassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__